<template>
    <div>
        <hr>
        <h2 class="ix-page-title-secondary mt-4">Attributs spécifiques</h2>
        
        <div class="ix-table-box mb-3">
            <table class="ix-table" v-if="attributes.length > 0">
                <thead>
                    <tr>
                        <th>Label</th>
                        <th>Valeur</th>
                        <th class="text-center" style="width: 50px;">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(attr, index) in attributes" :key="attr.uniq" :class="{'text-muted': !attr.value && !attr.id}">
                        <td>
                            <input 
                                type="text" 
                                v-model="attr.label" 
                                :class="['form-control', 'form-control-sm', {'is-invalid': getError(index, 'label')}]"
                                placeholder="Ex: Couleur, Marque..."
                            >
                            <div v-if="getError(index, 'label')" class="invalid-feedback" style="display: block;">
                                {{ getError(index, 'label') }}
                            </div>
                        </td>
                        <td>
                            <input 
                                type="text" 
                                v-model="attr.value" 
                                :class="['form-control', 'form-control-sm', {'is-invalid': getError(index, 'value')}]"
                                placeholder="Entrez une valeur"
                            >
                            <div v-if="getError(index, 'value')" class="invalid-feedback" style="display: block;">
                                {{ getError(index, 'value') }}
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="btn btn-sm transparent" @click="removeAttribute(index)">
                                <i class="far fa-trash"></i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <button 
            type="button" 
            class="ix-btn link"
            @click="addAttribute"
        >
            <i class="far fa-plus"></i> Ajouter un attribut
        </button>

        <!-- Hidden inputs pour soumettre les données -->
        <input 
            type="hidden" 
            v-for="(attr, index) in attributes" 
            :key="'label_' + attr.uniq"
            :name="'attributes[' + index + '][label]'"
            :value="attr.label"
        >
        <input 
            type="hidden" 
            v-for="(attr, index) in attributes" 
            :key="'value_' + attr.uniq"
            :name="'attributes[' + index + '][value]'"
            :value="attr.value"
        >
        <input 
            type="hidden" 
            v-for="(attr, index) in attributes" 
            :key="'id_' + attr.uniq"
            :name="'attributes[' + index + '][id]'"
            :value="attr.id"
            v-if="attr.id"
        >
    </div>
</template>

<script>
export default {
    name: 'article-attribute-form',
    props: {
        oldAttributes: {
            type: String,
            default: '[]'
        },
        labelsRoute: {
            type: String,
            default: '/api/articles/attributes/labels'
        },
        errors: {
            type: [Object, Array],
            default: () => ({})
        }
    },
    data() {
        return {
            attributes: [],
            availableLabels: []
        };
    },
    methods: {
        addAttribute() {
            this.attributes.push({
                uniq: Math.random().toString(36).substr(2, 9),
                id: null,
                label: '',
                value: ''
            });
        },
        removeAttribute(index) {
            this.attributes.splice(index, 1);
        },
        getError(index, field) {
            const key = `attributes.${index}.${field}`;
            return this.errors[key] ? this.errors[key][0] : null;
        },
        fetchDistinctLabels() {
            return fetch(this.labelsRoute, {
                ...{ method: 'GET' },
                ...this.getHttpJsonRequestHeaders()
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Failed to fetch attribute labels (HTTP ${response.status})`);
                    }

                    const contentType = response.headers.get('content-type') || '';
                    if (!contentType.includes('application/json')) {
                        throw new Error('Endpoint did not return JSON');
                    }

                    return response.json();
                })
                .then(labels => {
                    this.availableLabels = labels;
                })
                .catch(error => {
                    console.error('Error fetching attribute labels:', error);
                    this.availableLabels = [];
                });
        },
        initializeAttributes() {
            try {
                const oldAttrs = JSON.parse(this.oldAttributes);
                if (Array.isArray(oldAttrs)) {
                    this.attributes = oldAttrs.map(attr => ({
                        uniq: Math.random().toString(36).substr(2, 9),
                        id: attr.id || null,
                        label: attr.label || '',
                        value: attr.value || ''
                    }));
                }
            } catch (e) {
                console.log('Erreur parsing oldAttributes:', e);
                this.attributes = [];
            }

            // Récupérer les labels existants dans le formulaire
            const existingLabels = this.attributes.map(attr => attr.label);

            // Ajouter les labels disponibles qui ne sont pas déjà présents
            this.availableLabels.forEach(label => {
                if (!existingLabels.includes(label)) {
                    this.attributes.push({
                        uniq: Math.random().toString(36).substr(2, 9),
                        id: null,
                        label: label,
                        value: ''
                    });
                }
            });

            // Si aucun attribut, ajouter une ligne vide
            if (this.attributes.length === 0) {
                this.addAttribute();
            }
        }
    },
    mounted() {
        this.fetchDistinctLabels().then(() => {
            this.initializeAttributes();
        });
    }
}
</script>

<style scoped>
.ix-table {
    width: 100%;
}

.form-control-sm {
    height: 32px;
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
}

.text-muted {
    opacity: 0.6;
}
</style>
